// Chakra imports
import { Portal, Box, useDisclosure } from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin';
import Sidebar from 'components/sidebar/Sidebar';
import { SidebarContext } from 'contexts/SidebarContext';
import { LoadingProvider } from 'contexts/LoadingContext';
import { useState } from 'react';
import routes from 'routes';

// Custom Chakra theme
export default function Layout(props: { [x: string]: any }) {

	const { title, children, footer, renderSidebar, backButtonTo, ...rest } = props;
	// states and functions
	const [ fixed ] = useState(false);
	const [ toggleSidebar, setToggleSidebar ] = useState(false);

	// functions for changing the states from components

	const getActiveNavbar = (routes: RoutesType[]): boolean => {
		let activeNavbar = false;
		for (let i = 0; i < routes.length; i++) {
			if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
				return routes[i].secondary;
			}
		}
		return activeNavbar;
	};
	const getActiveNavbarText = (routes: RoutesType[]): string | boolean => {
		let activeNavbar = false;
		for (let i = 0; i < routes.length; i++) {
			if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
				return routes[i].name;
			}
		}
		return activeNavbar;
	};

	document.documentElement.dir = 'ltr';
	const { onOpen } = useDisclosure();

	return (
		<Box>
			<LoadingProvider>
				<SidebarContext.Provider
					value={{
						toggleSidebar,
						setToggleSidebar
					}}>
					{renderSidebar?<Sidebar routes={routes} display='none' {...rest} />:null}
					<Box
						float='right'
						minHeight='100vh'
						height='100%'
						overflow='auto'
						position='relative'
						maxHeight='100%'
						w={{ base: '100%', xl: renderSidebar?'calc( 100% - 220px )':'100%' }}
						maxWidth={{ base: '100%', xl: renderSidebar?'calc( 100% - 220px )':'100%' }}
						transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
						transitionDuration='.2s, .2s, .35s'
						transitionProperty='top, bottom, width'
						transitionTimingFunction='linear, linear, ease'>
						<Portal>
							<Box>
								<Navbar
									onOpen={onOpen}
									logoText={'Horizon UI Dashboard PRO'}
									brandText={title}
									secondary={getActiveNavbar(routes)}
									message={getActiveNavbarText(routes)}
									fixed={fixed}
									renderSidebar={renderSidebar}
									backButtonTo={backButtonTo}
									{...rest}
								/>
							</Box>
						</Portal>
						<Box pt={{ base: '30px', md: '30px', xl: '30px' }} px={{ base: '30px', md: '45px', xl: '45px' }}>
							{children}
						</Box>
						<Box>
							{footer?<Footer />:null}
						</Box>
					</Box>
				</SidebarContext.Provider>
			</LoadingProvider>
		</Box>
	);
}
